import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Info = forwardRef<SVGSVGElement | null, IconFilledProps>(function Info({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.5 20.5C17.1944 20.5 21 16.6944 21 12C21 7.30558 17.1944 3.5 12.5 3.5C7.80558 3.5 4 7.30558 4 12C4 16.6944 7.80558 20.5 12.5 20.5ZM12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M13.5 7C13.5 7.55228 13.0523 8 12.5 8C11.9477 8 11.5 7.55228 11.5 7C11.5 6.44772 11.9477 6 12.5 6C13.0523 6 13.5 6.44772 13.5 7Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 10.75H11.25C10.9739 10.75 10.75 10.5261 10.75 10.25V9.75C10.75 9.47386 10.9739 9.25 11.25 9.25H12.25C12.9404 9.25 13.5 9.80964 13.5 10.5V15.75H15.25C15.5261 15.75 15.75 15.9739 15.75 16.25V16.75C15.75 17.0261 15.5261 17.25 15.25 17.25H10.25C9.97386 17.25 9.75 17.0261 9.75 16.75V16.25C9.75 15.9739 9.97386 15.75 10.25 15.75H12V10.75Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12ZM12.5 8C13.0523 8 13.5 7.55228 13.5 7C13.5 6.44772 13.0523 6 12.5 6C11.9477 6 11.5 6.44772 11.5 7C11.5 7.55228 11.9477 8 12.5 8ZM11.25 10.75H12V15.75H10.25C9.97386 15.75 9.75 15.9739 9.75 16.25V16.75C9.75 17.0261 9.97386 17.25 10.25 17.25H15.25C15.5261 17.25 15.75 17.0261 15.75 16.75V16.25C15.75 15.9739 15.5261 15.75 15.25 15.75H13.5V10.5C13.5 9.80964 12.9404 9.25 12.25 9.25H11.25C10.9739 9.25 10.75 9.47386 10.75 9.75V10.25C10.75 10.5261 10.9739 10.75 11.25 10.75Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'info-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Info;
